import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { BookUser } from "lucide-react";

export const RubricaPicker = ({ ruolo, onPick }) => {
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const box = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const t = setTimeout(() => api.get("/sinistri/rubrica", { params: { ruolo, q } }).then(({ data }) => setItems(data)).catch(() => setItems([])), 200);
    return () => clearTimeout(t);
  }, [q, ruolo, open]);
  useEffect(() => {
    const close = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);
  return (
    <div className="relative" ref={box}>
      <BookUser className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
      <Input value={q} onChange={(e) => setQ(e.target.value)} onFocus={() => setOpen(true)} placeholder="Scegli dalla rubrica (nome o studio)…" className="pl-9 bg-slate-50" data-testid={`sin-rubrica-search-${ruolo}`} />
      {open && (
        <div className="absolute z-20 mt-1 w-full max-h-64 overflow-y-auto rounded-lg border border-slate-200 bg-white shadow-lg" data-testid={`sin-rubrica-list-${ruolo}`}>
          {items.length === 0 ? <p className="px-3 py-2 text-sm text-slate-400">Nessun nominativo in rubrica.</p>
            : items.map((r) => (
              <button key={r.id} type="button" onClick={() => { onPick(r); setOpen(false); setQ(""); }} className="w-full text-left px-3 py-2 hover:bg-slate-50 border-b border-slate-100 last:border-0" data-testid={`sin-rubrica-item-${r.id}`}>
                <div className="text-sm text-slate-800">{r.nome}{r.studio ? <span className="text-slate-500"> · {r.studio}</span> : null}</div>
                <div className="text-[11px] text-slate-500">{[r.telefono, r.email, r.pec].filter(Boolean).join(" · ") || "nessun recapito"}</div>
              </button>
            ))}
        </div>
      )}
    </div>
  );
};
